import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "oxd-topbar-body-nav-tab-item" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  href: "#",
  class: "oxd-topbar-body-nav-tab-link --more"
}
const _hoisted_4 = {
  key: 0,
  class: "oxd-topbar-body-nav-tab-accordian"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_dropdown_menu = _resolveComponent("oxd-dropdown-menu")!

  return (_openBlock(), _createBlock(_component_oxd_dropdown_menu, {
    class: "oxd-topbar-body-nav-tab",
    "onDropdown:closed": _ctx.onClose
  }, {
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `nav-level2-${index}`
        }, [
          _createElementVNode("li", {
            onClick: ($event: any) => (_ctx.onClickMenu($event, menuItem, index))
          }, [
            _createElementVNode("a", _hoisted_3, [
              _createTextVNode(_toDisplayString(menuItem.name) + " ", 1),
              _withDirectives(_createVNode(_component_oxd_icon, {
                name: index === _ctx.expandedIndex ? 'chevron-up' : 'chevron-down',
                "with-container": false
              }, null, 8, ["name"]), [
                [_vShow, menuItem.children.length > 0]
              ])
            ])
          ], 8, _hoisted_2),
          (_ctx.expandedIndex === index)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.children, (subMenuItem, _index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `nav-level3-${_index}`,
                    onClick: ($event: any) => (_ctx.onClickMenu($event, subMenuItem, -1))
                  }, [
                    _createElementVNode("a", _hoisted_6, _toDisplayString(subMenuItem.name), 1)
                  ], 8, _hoisted_5))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.t('general.more', 'More')) + " ", 1),
        _createVNode(_component_oxd_icon, {
          name: "three-dots-vertical",
          "with-container": false
        })
      ])
    ]),
    _: 1
  }, 8, ["onDropdown:closed"]))
}